import Image from 'components/Image'
import React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { authSelector } from 'redux/selector'
import Tippy from '@tippyjs/react/headless';
import ReplyForm from '../ReplyForm'

const RattingReplyItem = ({
    item,
    checkEdit,
    setShowModal,
    setMethod,
    setType,
    setNumberStar,
    setDataRatting,
    setContent,
    checkAdmin,
    checkShowModalControl,
    callBack
}) => {
    const authState = useSelector(authSelector)
    const [rattingReplyControl, setRattingReplyControl] = useState(false);

    return (
        <>
            <div className="header flex header_list">
                <div className="image b-grey-1">
                    <Image src={item.avatar} />
                </div>
                <div className="info ml-10">
                    <div className="text-black medium s-18">{item.full_name || "No Name"}
                        <span className="text-red s-14">{item.permission === 0 ? " - Quản trị viên" : item.permission === 1 ? " - Nhân viên" : " - Khách hàng"}</span>
                    </div>
                    <span className="text-grey s-14">{item.created_at.slice(0, 10)}</span>
                </div>
                <Tippy
                    interactive
                    placement='bottom'
                    visible={authState.isLoggedIn && rattingReplyControl}
                    onClickOutside={() => setRattingReplyControl(!rattingReplyControl)}
                    render={attrs => (
                        <div
                            className="rating_comment_control_box b-grey-1 bg-white"
                        >
                            {
                                checkEdit(item.account_id) &&
                                <>
                                    <span
                                        className="text-black px-10 clickable"
                                        onClick={() => {
                                            setShowModal(true)
                                            setMethod("edit")
                                            setType(1)
                                            setNumberStar(item.star)
                                            setDataRatting(item)
                                            setContent(item.content)
                                            setRattingReplyControl(!rattingReplyControl)
                                        }}
                                    >
                                        Chỉnh sửa
                                    </span>
                                    {/* <span
                                        className="text-black px-10 clickable"
                                        onClick={() => {
                                            setShowModal(true)
                                            setMethod("remove")
                                            setType(1)
                                            setNumberStar(item.star)
                                            setDataRatting(item)
                                            setContent(item.content)
                                        }}
                                    >
                                        Xóa
                                    </span> */}
                                </>
                            }
                            {
                                checkAdmin &&
                                <span
                                    className="text-black px-10 clickable"
                                    onClick={() => {
                                        setShowModal(true)
                                        setMethod("block")
                                        setType(1)
                                        setNumberStar(item.star)
                                        setDataRatting(item)
                                        setContent(item.content)
                                        setRattingReplyControl(!rattingReplyControl)
                                    }}
                                >
                                    Ẩn bình luận
                                </span>
                            }

                        </div>
                    )}
                >
                    {
                        checkShowModalControl(item.account_id) &&
                        <div className="rating_comment_control">
                            <i
                                onMouseEnter={() => setRattingReplyControl(!rattingReplyControl)}
                                className="ti-more-alt"
                            ></i>
                        </div>
                    }
                </Tippy>
            </div>
            {
                item.content &&
                <div className="content">
                    <div className="text-black s-16 word-break pre-line">{item.content}</div>
                </div>
            }
            <ReplyForm data={item} callBack={callBack} isReply={true} />
        </>
    )
}

export default RattingReplyItem